// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"i5-z","dimensionLabel":"j5-z","styleChooserControlWrapper":"k5-z","styleChooserControl":"l5-z","disabled":"m5-z","giftCard":"n5-z","styleChooserText":"o5-z"};